import { FetchWrapper } from "../fetchWrapper";

export interface ApiKey {
  id: number;
  name: string;
  keyPrefix: string;
  key: string | null;
  active: boolean;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string | null;
}

// ts-prune-ignore-next
export interface ApiKeyCreated extends ApiKey {
  key: string;
}

export const ApiKeysApiResource = (client: FetchWrapper) => {
  return {
    list: async (): Promise<ApiKey[]> => client.get("/api-keys"),
    create: async (name: string): Promise<ApiKeyCreated> => client.post("/api-keys", { name }),
    regenerate: async (keyId: number): Promise<ApiKeyCreated> => client.post(`/api-keys/${keyId}/regenerate`),
    revoke: async (keyId: number): Promise<{ revoked: boolean }> => client.delete(`/api-keys/${keyId}`),
  };
};
